import qs from 'query-string';

/**
 * 会将params中的所有属性都一一拼到url上
 * @param params
 * @param url
 */
export function setParamsToUrl(params: Record<string, string>, url: string) {
  const queryIndex = url.lastIndexOf('?');
  const hasQuery = queryIndex !== -1;
  const baseUrl = hasQuery ? url.slice(0, queryIndex) : url;
  const existingQuery = hasQuery ? qs.parse(url.slice(queryIndex + 1)) : null;
  return `${baseUrl}?${qs.stringify({
    ...existingQuery,
    ...params,
  })}`;
}

export default {};
